module.exports = __webpack_public_path__ + "static/media/(DH)-02-Capim-Dourado-bijuterias.beebc9af.jpg";